import mixpanel from 'mixpanel-browser';

const MIX_PANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN;
const IS_DEV = import.meta.env.DEV;

if (MIX_PANEL_TOKEN) {
  mixpanel.init(MIX_PANEL_TOKEN, {
    debug: IS_DEV,
    api_host: 'https://api-eu.mixpanel.com',
    track_pageview: false,
  });

  // Register super properties that should be sent with every event
  mixpanel.register({
    environment: import.meta.env.MODE,
  });
}

const trackableEvents = {
  freemiumSearch: 'Freemium Search',
  contactRequest: 'Contact Request',
  contactFormSubmit: 'Contact Form Submit',
  websiteLinkClick: 'Website Link Click',
  areaReportCreate: 'Area Report Create',
  areaGroupCreate: 'Area Group Create',
  excelExport: 'Excel Export',
  excelExportSelected: 'Excel Export Selected',
  goalAreaReadMore: 'Goal Area Read More',
};

type TrackableEvent = keyof typeof trackableEvents;

export const identifyUser = (
  userId: string,
  traits?: Record<string, string>
) => {
  if (!MIX_PANEL_TOKEN) return;

  mixpanel.identify(userId);

  if (traits) {
    mixpanel.people.set(traits);
  }
};

export const track = (
  event: TrackableEvent,
  properties?: Record<string, unknown>
) => {
  if (MIX_PANEL_TOKEN) {
    mixpanel.track(trackableEvents[event], properties);
  }
};

export const trackPageView = (path: string, search: string, url: string) => {
  if (MIX_PANEL_TOKEN) {
    mixpanel.track('Page View', {
      path,
      search,
      url,
    });
  }
};

export const resetUser = () => {
  if (MIX_PANEL_TOKEN) {
    mixpanel.reset();
  }
};
